import {
  ListItem,
  ListItemIcon,
  ListItemIconProps,
  ListItemProps,
  ListItemText,
  ListItemTextProps,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@forgeglobal/design-framework'
import React from 'react'

const useTextStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        fontWeight: '300 !important' as any,
      },
    },
  })
)

const useIconStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 'unset',
      paddingRight: theme.spacing(2),
    },
  })
)

const useItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  })
)

export const PopoverListItemIcon: React.FC<ListItemIconProps> = props => {
  const classes = useIconStyles({})
  return (
    <Typography variant="h5" color="textSecondary" style={{ lineHeight: 'unset' }}>
      <ListItemIcon {...props} classes={classes} />
    </Typography>
  )
}

export const PopoverListItemText: React.FC<ListItemTextProps> = props => {
  const classes = useTextStyles({})
  return (
    <Typography variant="body2" color="textSecondary" component="span">
      <ListItemText {...props} classes={classes} />
    </Typography>
  )
}

export const PopoverListItem: React.FC<ListItemProps> = props => {
  const classes = useItemStyles({})
  return <ListItem {...(props as any)} classes={classes} />
}
